import { Booking, Table } from "@greeter/core";
import { DatePeriod } from "@greeter/date";
import { addHours } from "date-fns";
import { mockOrder } from "./MockOrder";

export const mockTable: Table = {
  type: "table",
  number: 1,
  minCapacity: 2,
  maxCapacity: 4,
  minPrice: 0,
};

export const mockBooking: Booking = {
  id: "",
  status: "created",
  tables: new Map<string, Table[]>().set("Bier Halle", [
    mockTable,
    { ...mockTable, number: 2 },
  ]),
  venueId: "",
  createdAt: new Date(),
  customerId: "",
  groupSize: 5,
  period: new DatePeriod({ from: new Date(), to: addHours(new Date(), 6) }),
  order: mockOrder,
  comment: "",
  createdBy: "customer"
};
